import React from 'react';

import type { TemplateVariableComponentProps } from './types.ts';
import {
	TemplateVariableNameWrapper,
	TemplateVariableName,
	TemplateVariableType,
} from './SharedComponents.tsx';

export const TemplateVariableComponent = ({
	parameters,
}: TemplateVariableComponentProps): React.JSX.Element => {
	return (
		<span>
			<TemplateVariableNameWrapper>
				<TemplateVariableName data-testid="variable-name">{parameters?.name}</TemplateVariableName>
			</TemplateVariableNameWrapper>
			<TemplateVariableType data-testid="variable-type">
				{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
				{`| ${parameters?.type}`}
			</TemplateVariableType>
		</span>
	);
};
